import { render } from "./ListReminders.vue?vue&type=template&id=0e07303b"
import script from "./ListReminders.vue?vue&type=script&lang=js"
export * from "./ListReminders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__